import React from 'react'

const EMPTY = '—'
const BASE_SUBTITLE = 'of billed dollars collected'
const BASE_INFO = 'Share of the dollars billed in the period that actually cleared.'

export const formatRatio = (ratio) => (ratio != null ? `${Math.round(ratio * 100)}%` : EMPTY)

export const unsplitSentence = (unsplitShare) => {
  if (!(unsplitShare > 0)) return ''
  const rounded = Math.round(unsplitShare * 100)
  const label = rounded === 0 ? 'Under 1%' : `${rounded}%`
  return ` ${label} of these dollars have no card or bank method on record (for example a deleted method or an affiliate-billed account) and count only in the overall figure.`
}

export const CollectionRateSplitValue = ({ bank, card }) => (
  <span className="flex flex-wrap items-end gap-x-6 gap-y-1">
    <span className="flex flex-col">
      <span className="text-[12px] font-medium text-text-secondary">Bank / ACH</span>
      <span>{formatRatio(bank)}</span>
    </span>
    <span className="flex flex-col">
      <span className="text-[12px] font-medium text-text-secondary">Card</span>
      <span>{formatRatio(card)}</span>
    </span>
  </span>
)

export const collectionRateCardProps = (metrics) => {
  const split = metrics?.collectionRateByMethod
  if (!split || typeof split !== 'object') {
    return {
      value: formatRatio(metrics?.collectionRate),
      subtitle: BASE_SUBTITLE,
      info: BASE_INFO,
    }
  }
  return {
    value: <CollectionRateSplitValue bank={split.bank} card={split.card} />,
    subtitle: `${formatRatio(metrics.collectionRate)} overall · ${BASE_SUBTITLE}`,
    info: `${BASE_INFO} Bank / ACH and Card use the payment's billing method.${unsplitSentence(split.unsplitShare)} Bank figures can still fall: a bank return can arrive days after the payment cleared.`,
  }
}
